module.exports = __webpack_public_path__ + "static/media/Destinos.b7c723f5.png";